







































import { Vue, Component, Prop } from "vue-property-decorator";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { Course as ICourse } from "@/api/models/course";
import { Lecture as ILecture } from "@/api/models/lecture";
import { Video as IVideo } from "@/api/models/video";

@Component
export default class Unpublished extends Vue {
  @Prop() webinarCount!: number;
  @Prop() webinarDisabledCount!: Array<IWebinar>;
  @Prop() courseCount!: number;
  @Prop() coursesDisabledCount!: Array<ICourse>;
  @Prop() lecturesCount!: number;
  @Prop() lectureDisabledCount!: Array<ILecture>;
  @Prop() videosCount!: number;
  @Prop() videosDisabledCount!: Array<IVideo>;
}
